import { render, staticRenderFns } from "./contractBooking.vue?vue&type=template&id=08c047b0&scoped=true&"
import script from "./contractBooking.vue?vue&type=script&lang=js&"
export * from "./contractBooking.vue?vue&type=script&lang=js&"
import style0 from "./contractBooking.vue?vue&type=style&index=0&id=08c047b0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c047b0",
  null
  
)

export default component.exports